import { styled } from '@linaria/react';

export const StyledIFrame = styled.iframe`
	display: none;
`;
